<template>
  <div class="artical">
    <div class="title">{{ detailData.postTitle }}</div>
    <div class="date">{{ detailData.postDate }}</div>
    <div class="txt" v-html="detailData.postContent"></div>
  </div>
</template>

<script>
export default {
  name: "Artical",
  props: ["detailData"],
  created() {
    this.handleFont();
  },
  methods: {
    handleFont() {
      this.$nextTick(() => {
        var spanArr = $(".txt").find("span");
        for (var i = 0; i < spanArr.length; i++) {
          var a = $(spanArr[i]).attr("style");
          if (
            $(spanArr[i])
              .attr("style")
              .indexOf("font-weight") != -1
          ) {
            $(spanArr[i]).addClass("speFont");
            // console.log('加上了1');
            this.$forceUpdate();
          }
        }
      });
    },
  },
  watch: {},
};
</script>

<style lang="less">
.speFont {
  font-family: Open SansBold !important;
}

.artical {
  padding: 0 0.5rem;
  .title {
    font-size: 0.5rem;
    font-family: FranklinGothic-Demi;
    font-weight: 400;
    color: #2f2f2f;
    line-height: 1.5;
    font-weight: bold;
  }
  .date {
    font-size: 0.36rem;
    font-family: Open Sans;
    font-weight: 400;
    color: #333333;
    line-height: 1rem;
  }
  .txt {
    font-size: 0.4rem;
    font-family: Open Sans;
    font-weight: 400;
    // line-height: 0.7rem;
    padding: 0 0 15px 0;
    // word-break:break-all;
    img {
      width: 100% !important;
      height: auto !important;
    }
    h1 {
      font-size: 0.9rem;
    }
    h2 {
      font-size: 0.7rem;
    }
    h3 {
      font-size: 0.5rem;
    }
    h4 {
      font-size: 0.4rem;
    }
    h5 {
      font-size: 0.35rem;
    }
    p {
      margin: 0;
    }
  }
}
@media screen and (max-width: 768px) {
  .txt {
    font-size: 0.44rem;
    font-family: Open Sans;
    font-weight: 400;
    line-height: 0.7rem;
    padding: 0 0 15px 0 !important;
  }
}
@media screen and (min-width: 768px) {
  .detialBox {
    .artical {
      padding: 0;
    }
    .title {
      // font-size: 0.35rem;
      font-family: FranklinGothic-Demi;
      font-weight: 400;
      color: #2f2f2f;
      // line-height: 0.6rem;
      font-weight: bold;
    }
    .txt {
      font-size: 0.2rem;
      font-family: Open Sans;
      font-weight: 400;
      line-height: 26px;
      padding: 0 0 15px 0;
    }
    .date {
      font-size: 0.2rem;
      font-family: Open Sans;
      font-weight: 400;
      color: #333333;
      line-height: 0.8rem;
    }
  }
}
</style>
